import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M7 21h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m13 12 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Salad";
const Salad = memo(themed(Icon));
export {
  Salad
};
//# sourceMappingURL=salad.js.map
